import { theme, type ThemeConfig } from 'antd';

export const layoutTheme: ThemeConfig = {
  token: {
    colorPrimary: '#1890ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1890ff',
    borderRadius: 6,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 14,
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f0f2f5',
  },
  components: {
    Button: {
      primaryShadow: '0 2px 0 rgba(24, 144, 255, 0.1)',
    },
    Card: {
      borderRadiusLG: 8,
    },
    Table: {
      borderRadiusLG: 8,
    },
    Menu: {
      itemBorderRadius: 6,
      subMenuItemBorderRadius: 6,
    },
  },
};

export const darkTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: '#1890ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1890ff',
    borderRadius: 6,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 14,
    colorBgContainer: '#141414',
    colorBgLayout: '#000000',
    colorBgElevated: '#1f1f1f',
    colorText: 'rgba(255, 255, 255, 0.88)',
    colorTextSecondary: 'rgba(255, 255, 255, 0.65)',
    colorBorder: '#424242',
    colorBorderSecondary: '#303030',
  },
  components: {
    Button: {
      primaryShadow: '0 2px 0 rgba(24, 144, 255, 0.1)',
    },
    Card: {
      borderRadiusLG: 8,
      colorBgContainer: '#141414',
    },
    Table: {
      borderRadiusLG: 8,
      colorBgContainer: '#141414',
      headerBg: '#1f1f1f',
      rowHoverBg: '#1f1f1f',
    },
    Menu: {
      itemBorderRadius: 6,
      subMenuItemBorderRadius: 6,
      darkItemBg: '#141414',
      darkSubMenuItemBg: '#141414',
    },
    Select: {
      colorBgContainer: '#141414',
      colorBgElevated: '#1f1f1f',
    },
    Input: {
      colorBgContainer: '#141414',
    },
    Switch: {
      colorPrimary: '#1890ff',
    },
  },
};